import { useMutation, useQueryClient } from 'react-query';
import { useDoctorPortalApiContext } from 'contexts/ApiContext';
import {
  PhysicalExaminationType,
  requestGenerateThroatExaminationVideo,
} from '@higo/api';
import { useDispatchDoctorTrackedType } from 'hooks/useDispatchDoctorTrackedEvent';
import { DoctorTrackedType } from '@higo/common/lib/features/TrackedEvent';

export const useRequestGenerateThroatExaminationVideoMutation = () => {
  const { authorizedAxios } = useDoctorPortalApiContext();
  const queryClient = useQueryClient();
  const sendTrackedEvent = useDispatchDoctorTrackedType();

  return useMutation(requestGenerateThroatExaminationVideo(authorizedAxios), {
    onSuccess: (_, variables) => {
      sendTrackedEvent({
        event: DoctorTrackedType.RequestVisualExaminationVideo,
        eventResult: 'success',
        physicalExaminationType: PhysicalExaminationType.Throat,
        examinationId: variables,
      });
    },

    onError: (error, variables, context) => {
      sendTrackedEvent({
        event: DoctorTrackedType.RequestVisualExaminationVideo,
        eventResult: 'error',
        physicalExaminationType: PhysicalExaminationType.Throat,
        examinationId: variables,
      });

      // call global error handler
      return queryClient
        .getDefaultOptions()
        ?.mutations?.onError?.(error, variables, context);
    },
  });
};
